<template>
  <div>
    <!--切换tab-->
    <div class="navga_out mt20">
      <a class="navga_tab"
         v-for="(item,index) in tabTittles"
         v-if="!item == ''"
         :class="{cur:tableIndex == item.index}"
         @click="tab(item.index)"
         href="javascript:void(0);">
        {{item.title}}
      </a>
      <!--table_titles:index==1 && retirementYear==2017-->
    </div>
    <!-- 切换tab end-->

    <table0 v-if="tableIndex == 0"></table0>
    <table2016 v-if="tableIndex == 'table2016'"></table2016>
    <table2017 v-if="tableIndex == 'table2017'"></table2017>
    <table2018 v-if="tableIndex == 'table2018'"></table2018>
    <table2019 v-if="tableIndex == 'table2019'"></table2019>
    <table2020 v-if="tableIndex == 'table2020'"></table2020>
    <table2021 v-if="tableIndex == 'table2021'"></table2021>
    <table2022 v-if="tableIndex == 'table2022'"></table2022>
    <table2023 v-if="tableIndex == 'table2023'"></table2023>
    <table2024 v-if="tableIndex == 'table2024'"></table2024>
    <table2025 v-if="tableIndex == 'table2025'"></table2025>
  </div>

</template>
<script>
  import table0 from './pension/table0'
  import table2016 from '../components/pension/table2016'
  import table2017 from '../components/pension/table2017'
  import table2018 from '../components/pension/table2018'
  import table2019 from '../components/pension/table2019'
  import table2020 from '../components/pension/table2020'
  import table2021 from '../components/pension/table2021'
  import table2022 from '../components/pension/table2022'
  import table2023 from '../components/pension/table2023'
  import table2024 from '../components/pension/table2024'
  import table2025 from '../components/pension/table2025'

  export default {
    name: 'pension_table',
    data() {
      return {
        tabTittles: [],
        tableIndex: 0,
        retirementYear: '',
        ishave: true,
        tempArr: []
      }
    },
    components: {
      'table0': table0,
      'table2016': table2016,
      'table2017': table2017,
      'table2018': table2018,
      'table2019': table2019,
      'table2020': table2020,
      'table2021': table2021,
      'table2022': table2022,
      'table2023': table2023,
      'table2024': table2024,
      'table2025': table2025,
    },
    created: function () {

    },
    mounted() {
      console.log("浙江省机关事业养老保险待遇计发")
      this.retirementYear = window.sessionStorage.getItem('retirementTime').split('-')[0];
      this.retirementMonth = window.sessionStorage.getItem('retirementTime').split('-')[1];
      this.retirementDay = window.sessionStorage.getItem('retirementTime').split('-')[2];
      this.tempArr = window.sessionStorage.getItem('key');
      console.log(this.retirementYear);
      console.log(this.retirementMonth);
      console.log(this.retirementDay);

      let timeTempKeys = this.tempArr ? this.tempArr.split(",") : []
      let startYear = Math.max(this.retirementYear, 2016)
      let nowYear = (new Date()).getFullYear()

      this.tabTittles = [{"title": '浙江省机关事业养老保险待遇计发（预发）表', "index": 0}];
      for (var inx in timeTempKeys) {
        let y = timeTempKeys[inx]
        if (y >= startYear) {
          this.tabTittles.push({"title": y + '基本养老金调整明细表', "index": "table" + y})
        }
      }

      // 今年退休的，特殊处理
      if (this.retirementYear == nowYear) {
        if (parseInt(this.retirementMonth) < 7 || (parseInt(this.retirementMonth) == 7 && parseInt(this.retirementDay) == 1)) {
          this.tabTittles = [{"title": '浙江省机关事业养老保险待遇计发（预发）表', "index": 0}];
        }
      }

      if (this.retirementYear == 2017) {
        this.ishave = false;
      }


    },
    methods: {
      tab: function (index) {
        console.log(index)
        this.tableIndex = index;
      }
    },
  }
</script>
<style lang="less">
  .navga_out {
    height: 38px;
    border-bottom: 1px solid #e1e7f6;
    border-left: 1px solid #e1e7f6;
    margin-bottom: 24px;
  }

  .navga_out {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
    margin-bottom: 50px;
  }

  .navga_out .navga_tab,
  .navga_out a,
  .navga_out span {
    height: 37px;
    text-align: center;
    line-height: 37px;
    color: #32363a;
    background: #fff;
    border-top: 1px solid #e1e7f6;
    border-right: 1px solid #e1e7f6;
    font-size: 14px;
    cursor: pointer;
    padding: 0 10px;
    text-decoration: none;
    white-space: nowrap;
  }

  .navga_out .navga_out_a {
    width: 98px;
    height: 37px;
    text-align: center;
    line-height: 37px;
    color: #00a5fa;
    background: #fff;
    border: 0;
    border-top: 1px solid #e1e7f6;
    border-right: 1px solid #e1e7f6;
    font-size: 16px;
    cursor: pointer;
    white-space: nowrap;
  }

  .navga_out span.cur,
  .navga_out a.cur {
    border-top: 3px solid #00a5fa;
    border-bottom: 0px;
    background: white;
    color: #32363a;
    height: 36px;
  }

  .navga_out .navga_out_label {
    display: inline-block;
    width: auto;
    height: 37px;
    text-align: center;
    line-height: 37px;
    color: #32363a;
    font-size: 16px;
    margin-left: -1px;
    cursor: pointer;
  }

  .table_titles {
    padding: 0 !important;
    border-right: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pension_table.vue